import './App.css';
import Home from './scripts/Home/Home';
import About from './scripts/About/about';
import Footer from './scripts/Footer/footer';
function App() {
  return (
    <div style={{backgroundColor:"#282d32"}}>
          <Home/>
          <About/>
          <Footer/>
    </div>

  );
}

export default App;
